import * as React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../core/state/state';
import { UserRoleType } from '../../../core/state/user/types';

interface Props {
  inRoles?: UserRoleType[];
}

const Role: React.FC<Props> = ({ inRoles, children }) => {
  const userRoles = useSelector((state: RootState) => state.user.userInfo?.userRole);

  if (!inRoles) {
    return <>{children}</>;
  }
  if (inRoles && userRoles && userRoles.find((val) => inRoles.includes(val.name))) {
    return <>{children}</>;
  }
  return null;
};

export default Role;
